import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DatiPignoramentoFormComponent } from 'src/app/common/form/dati-pignoramento-form.component';
import { DatiPignoramento } from 'src/app/common/models/dati-pignoramento/dati-pignoramento';
import { DatiPignoramentoResponse } from 'src/app/common/models/dto/dati-pignoramento-response';
import { SezioneDatiPignoramento } from 'src/app/common/models/sezioni/sezione-dati-pignoramento';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { FormValidationService } from '../../../services/form-validation.service';

@Component({
    selector: 'div [dati-pignoramento-form-add]',
  templateUrl: '../../../form/dati-pignoramento-form.html'
})
export class DatiPignoramentoAddComponent extends DatiPignoramentoFormComponent {
  urlAddBene: string;
  idFascicolo: string;
  idSezione: string;
  @Output()
    onReturn: EventEmitter<SezioneDatiPignoramento> = new EventEmitter<SezioneDatiPignoramento>();

  constructor(@Inject(OperationsService) operationService: OperationsService,
              @Inject(FormBuilder) campiForm,
              @Inject(HelpersService) helpers: HelpersService,
              @Inject(FormValidationService) formValidationService: FormValidationService) {
        super(operationService, campiForm, helpers, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Aggiungi dati pignoramento');
    this.isInserimento(true);
  }

  getDatiPignoramento(): DatiPignoramento {
    return new DatiPignoramento();
  }

  getRequest(datiPignoramento: DatiPignoramento) {
    this.operationService.createDatiPignoramento(this.urlAddBene, this.idFascicolo, this.idSezione, datiPignoramento).subscribe(response => this.datiPignoramentoCreated(response));
  }

  datiPignoramentoCreated(response: DatiPignoramentoResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(urlAddBene: string, idFascicolo: string, idSezione) {
    this.urlAddBene = urlAddBene;
    this.idFascicolo = idFascicolo;
    this.idSezione = idSezione;
    this.createForm();
  }
}
